const constants = {
  perMaxLen: 90000000
};

export default () => constants;
